import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="grid min-h-svh place-items-center p-8">
          <div className="max-w-lg space-y-3">
            <p className="text-sm font-semibold text-red-600 dark:text-red-400">App error</p>
            <pre className="overflow-auto rounded border bg-muted p-4 text-xs">
              {error.message}
              {'\n'}
              {error.stack}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
